import { render, staticRenderFns } from "./ClientPersonal.vue?vue&type=template&id=ae384ad4"
import script from "./ClientPersonal.vue?vue&type=script&lang=js"
export * from "./ClientPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports